import { Box, Grid, Slider, Stack, Typography } from '@mui/material';

// Reusable labelled slider row used across the live-stream auto-kick / goals settings UIs.
const SliderSetting = ({
    label,
    value,
    onChange,
    min,
    max,
    step = 1,
    unit,
    helperText,
    disabled = false,
}: {
    label: string;
    value: number;
    onChange: (val: number) => void;
    min: number;
    max: number;
    step?: number;
    unit: string;
    helperText?: string;
    disabled?: boolean;
}) => (
    <Grid mb={3}>
        <Stack direction="row" justifyContent="space-between" alignItems="baseline" mb={0.5}>
            <Typography variant="subtitle2">{label}</Typography>
            <Typography
                variant="h6"
                color={disabled ? 'text.disabled' : 'primary.main'}
                fontWeight={700}
                sx={{ minWidth: 80, textAlign: 'right', transition: 'color 0.2s' }}
            >
                {value}{' '}
                <Typography component="span" variant="caption" color="text.secondary">
                    {unit}
                </Typography>
            </Typography>
        </Stack>
        <Box sx={{ pl: 1, pr: 1 }}>
            <Slider
                value={value}
                min={min}
                max={max}
                step={step}
                disabled={disabled}
                onChange={(_, val) => onChange(val as number)}
                valueLabelDisplay="off"
                color="primary"
                sx={{ mt: 1 }}
            />
        </Box>
        {helperText && (
            <Typography variant="caption" color="text.secondary">
                {helperText}
            </Typography>
        )}
    </Grid>
);

export default SliderSetting;
